import { clearCookies } from './clearCookies';

// @ts-ignore
const NEXT_PUBLIC_AIDT_SSO_AGENT_HOST = process.env.NEXT_PUBLIC_AIDT_SSO_AGENT_HOST ?? '';

export const sessionTokenInvalidate = async () => {
  await fetch(NEXT_PUBLIC_AIDT_SSO_AGENT_HOST + '/sessionTokenInvalidate', {
    method: 'POST',
    mode: 'cors',
    keepalive: true,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  clearCookies();
};
